export default "__VITE_ASSET__DEM_seX9__"